/* globals jQuery, ClipboardJS */
jQuery( $ => {
	const $window = $( window );
	const $document = $( document );
	const $html = $( 'html' );
	const $body = $( 'body' );

	// =========================
	// ! Supports Flagging
	// =========================

	$body.removeClass( 'no-js' ).addClass( 'js' );

	$document
		.on( 'touchstart', function() {
			$body.removeClass( 'notouch' ).addClass( 'touch' );
		} )
		.on( 'mousedown', function() {
			$body.addClass( 'using-mouse' );
		} )
		.on( 'keydown', function() {
			$body.removeClass( 'using-mouse' );
		} );

	// =========================
	// ! Nav Toggle
	// =========================

	$( '.flyout-toggle' ).click( function() {
		$body.toggleClass( 'show-flyout' );
	} );

	// =========================
	// ! Page Chunking
	// =========================

	$( '.page-content' ).find( 'h2[id], h3[id]' ).each( function() {
		const $content = $( this ).nextUntil( 'h2[id], h3[id]' ).wrapAll( '<div class="chunk"></div>' );
		if ( $content.length > 0 ) {
			const $chunk = $( this ).next( '.chunk' );
			$chunk.attr( 'id', this.id ).prepend( this );
			this.removeAttribute( 'id' );
		}
	} );

	// =========================
	// ! Intersection Observers
	// =========================

	if ( typeof IntersectionObserver !== 'undefined' ) {
		const topMargin = $html.css( 'margin-top' ) || '0px';

		// =========================
		// ! - Page Nav Scroll Spy
		// =========================

		const $nav = $( '.page-nav' );
		const $links = $( '.page-nav__item' );
		const $pointer = $( '.page-nav__pointer' );
		const $chunks = $( '.page-content .chunk' );

		let navScrollUpdate;

		const headingObserver = new IntersectionObserver( changes => {
			changes.forEach( change => {
				$( change.target ).toggleClass( 'in-view', change.isIntersecting );
			} );

			// Find the "current" chunk in view
			let $currentChunk = $chunks.filter( '.in-view' );
			// In case of multiple, use the first one who's
			// top isn't outside the viewport
			if ( $currentChunk.length > 1 ) {
				const scrollTop = $window.scrollTop();
				$currentChunk = $currentChunk.filter( function() {
					return $( this ).offset().top >= scrollTop - 100;
				} ).first();
			}

			const $link = $links.removeClass( 'is-current' ).filter( `[href="#${ $currentChunk.attr( 'id' ) }"]` ).addClass( 'is-current' );
			if ( $link.length > 0 ) {
				$pointer.css( 'top', $link.position().top + ( $link.outerHeight() / 2 ) );

				clearTimeout( navScrollUpdate );
				navScrollUpdate = setTimeout( () => {
					$nav.scrollTop( $link.position().top );
				}, 500 );
			}
		}, {
			rootMargin: `${ topMargin } 0px 50px`,
		} );

		$( '.page-content' ).find( 'h2[id], h3[id], .chunk[id]' ).each( function() {
			headingObserver.observe( this );
		} );
	}

	$window.scroll( function() {
		$body.toggleClass( 'show-totop', $window.scrollTop() > window.innerHeight / 2 );
	} );

	// =========================
	// ! Resize Observers
	// =========================

	if ( typeof ResizeObserver !== 'undefined' ) {
		const navObserver = new ResizeObserver( entries => {
			const [ nav ] = entries;

			$body.toggleClass( 'has-scrolling-page-nav', nav.borderBoxSize[ 0 ].blockSize >= window.innerHeight );
		} );

		$( '.page-nav' ).each( function() {
			navObserver.observe( this );
		} );
	}

	// =========================
	// ! Clipboard Links
	// =========================

	if ( typeof ClipboardJS !== 'undefined' ) {
		$( '.share-button[rel="bookmark"]' ).click( e => e.preventDefault() );

		const clipboard = new ClipboardJS( '.share-button[rel="bookmark"]', {
			text( trigger ) {
				return trigger.getAttribute( 'href' );
			},
		} );

		clipboard.on( 'success', function( e ) {
			$( e.trigger ).append( '<span class="tooltip">Link copied to clipboard</span>' );
		} );
	}
} );
